import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['6 Tomos PDF completos (Fundamentos, Cuerpo, Técnica, Aparatos I y II, El Año Completo)', 'Progresiones paso a paso en los 5 aparatos', '6 Bonos incluidos gratis (valor $66.000)', 'Iniciación → Avanzado con variantes por nivel', 'Acceso inmediato + Garantía de 7 días'];
const premiumFeatures = ['TODO Gimnasia Rítmica PRO (6 Tomos + 6 Bonos)', 'Biblioteca Avanzada Rítmica Élite completa', 'Progresiones élite para habilidades complejas', 'Fichas técnicas de giros dobles y triples con diagnóstico', 'Protocolo de preparación competitiva: simulación y tapering', 'Análisis post-competencia y coordinaciones de riesgo'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'GIMNASIA RÍTMICA PRO + RÍTMICA ÉLITE' : 'GIMNASIA RÍTMICA PRO';
  const subtitle = premium ? '6 Tomos + 6 Bonos + Biblioteca Avanzada para grupos competitivos' : '6 Tomos + 6 Bonos · Todos los niveles · Los 5 aparatos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$70.000' : '$66.000';
  const savings = premium ? '$42.010' : '$46.010';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-2 border-gold bg-surface shadow-[0_25px_70px_rgba(245,199,75,.18)] md:scale-[1.025]' : 'border border-line bg-surface'}`} data-id="element-244" data-mp="3d9qoicfsr6t8">
      {premium && <p className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-gold px-4 py-1.5 text-xs font-black uppercase text-ink" data-id="element-245" data-mp="3ryddl5v87cxn">
          <StarIcon aria-hidden="true" className="h-4 w-4 fill-current" data-id="element-246" data-mp="2zhkj9le6mk8k" /> Más elegido
        </p>}
      <div className={premium ? 'mt-2' : ''} data-id="element-247" data-mp="2rgv09f5lnye9">
        <div className="flex items-start gap-2" data-id="element-248" data-mp="2rfjw3e88somm">
          <span aria-hidden="true" className="text-3xl" data-id="element-249" data-mp="2mhrt9p627i3n">
            {premium ? '🏆' : '📘'}
          </span>
          <h3 className="text-xl font-black uppercase leading-tight text-white" data-id="element-250" data-mp="316ejwn14zwa6">{title}</h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-gold-soft' : 'text-zinc-300'}`} data-id="element-251" data-mp="2w71nbakgraue">
          {subtitle}
        </p>
      </div>

      <ul className="my-6 flex-1 space-y-2" data-id="element-252" data-mp="28iinzkje68eg">
        {features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm font-medium text-zinc-200" data-id="element-253" data-mp="23k7fpe8qw5yc">
            <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-254" data-mp="2igy7p2g3afdx" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6 mt-auto" data-id="element-255" data-mp="3tvbq3rs2q2mk">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-black uppercase ${premium ? 'bg-gold text-ink' : 'bg-gold/15 text-gold'}`} data-id="element-256" data-mp="3tuaenm75be4b">
          Ahorrás {savings}
        </span>
        <p className="mt-2 text-sm font-bold text-zinc-500 line-through" data-id="element-257" data-mp="cgjxzyaiwzv">Antes: {before}</p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[.14em] text-zinc-400" data-id="element-258" data-mp="5aruye0bndjo">Hoy</p>
        <p className="text-4xl font-black text-gold md:text-5xl" data-id="element-259" data-mp="3ngwemd6iiu6k">
          {price} <span className="text-base font-bold text-zinc-300" data-id="element-260" data-mp="3rhq1r4c4s4ye">ARS</span>
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth variant={premium ? 'gold' : 'outline'} className="text-xs md:text-sm" data-id="element-261" data-mp="j1wlmqlpovhv">
        {premium ? 'Quiero el pack completo + Rítmica Élite →' : 'Quiero mi Gimnasia Rítmica PRO →'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-262" data-mp="11yobjivre8uw">
      <div className="text-center" data-id="element-263" data-mp="16qplgy5gfnhr">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-gold md:text-sm" data-id="element-264" data-mp="16rqy3724ci1l">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-6" data-id="element-265" data-mp="3a85yvqea6vn1">
          <Countdown data-id="element-266" data-mp="3a6uk6vjas3h5" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-267" data-mp="359cjttjciwkr">
          {['Después sube $8.000 ARS. No vuelve.', '68% de los cupos al precio de lanzamiento ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-500/40 bg-red-500/10 px-3 py-1.5 text-[11px] font-bold text-red-300" data-id="element-268" data-mp="1svozw45gm4p">
              <AlertTriangleIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-269" data-mp="3o75de582xu5h" />
              {item}
            </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-black uppercase text-white md:text-5xl" data-id="element-270" data-mp="kj3mnyp2ykdi">
        Elegí tu <span className="text-gold" data-id="element-271" data-mp="fsex4owynxh0">pack</span>
      </h2>
      <div className="mx-auto mt-12 grid max-w-5xl items-stretch gap-8 md:grid-cols-2" data-id="element-272" data-mp="fqu2z0ek6gjo">
        <PlanCard data-id="element-273" data-mp="1yggd90r0t029" />
        <PlanCard premium data-id="element-274" data-mp="1ygzjhk7b600g" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-zinc-400" data-id="element-275" data-mp="23dycu0j5e2xl">
        🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 🛡️ Garantía 7 días · 💳 Mercado Pago | Tarjeta
        | Transferencia
      </p>
    </section>;
}